import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Ourpartner from '../../components/Ourparnter';
import ScrollToTop from '../../components/ScrollToTop';
import InitialImage from './assets/NITTE_AIC.webp';
import infraandequipments from './assets/what we build.webp';
import infra2 from './assets/infra and equipments1.webp';
import infra1 from './assets/infra and equipments3.webp';
import whymakerspace from './assets/marketspace.webp';
import infra5 from './assets/CAD-Design-and-Software.webp';
import infra4 from './assets/Workstations.webp';
import infra3 from './assets/infrastructure  IoT.webp';
import webuild from './assets/what we builds.webp';
import makeinindia from './assets/Make_In_India.webp';
import './IdeaLabs.css';
import build from './assets/build.webp';
import design from './assets/3D-View.webp';
import enable from './assets/enable.webp';
import discover from './assets/discover.webp';
import feature1 from './assets/1.webp';
import feature2 from './assets/2.webp';
import feature3 from './assets/3.webp';
import feature4 from './assets/4.webp';
import feature5 from './assets/5.webp';
import whyIcon1 from './assets/7.webp';
import whyIcon2 from './assets/6.webp';
import whyIcon3 from './assets/8.webp';

import {
    FaTools,
    FaDraftingCompass,
    FaCogs,
    FaHandsHelping
} from "react-icons/fa";

const features = [
    { image: feature1, title: "Faster", subtitle: "concept-to-prototype" },
    { image: feature2, title: "Rapid testing &", subtitle: "iteration" },
    { image: feature3, title: "Industry-ready", subtitle: "portfolios" },
    { image: feature4, title: "Stronger research", subtitle: "output" },
    { image: feature5, title: "Attracts", subtitle: "collaborations" },
];

export default function MakerspaceHEI() {
    useEffect(() => {
        // Intersection Observer for scroll animations
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        // Observe all elements with animation classes
        const animatedElements = document.querySelectorAll('.scroll-animate, .fade-in-left, .fade-in-right, .scale-in, .fade-in, .stagger-item, .rotate-in, .slide-up, .bounce-in, .blur-in, .feature-icon, .image-zoom, .text-reveal');

        animatedElements.forEach(el => observer.observe(el));

        // Cleanup
        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <ScrollToTop />
            <div className="relative w-full">
                <img
                    src={InitialImage}
                    alt="Products Background"
                    className="w-full h-[900px] object-cover object-center"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center sm:mb-96 lg:mb-0  z-10 max-w-4xl mx-auto">
                    <h1 className="Utility-font-Montserrat text-white text-3xl sm:text-4xl lg:text-6xl font-bold text-center mb-1">
                        IDEA  Labs for HEI
                    </h1>
                    <p className="Utility-font-Buenard text-white text-lg md:text-2xl max-w-2xl mx-auto mb-6">
                        Empowering Higher Education Institutions with state-of-the-art <br /> innovation labs and prototyping facilities.
                    </p>
                    <button
                        onClick={() => document.getElementById('makerspace-intro').scrollIntoView({ behavior: 'smooth' })}
                        className="bg-sky-500 hover:bg-sky-600 text-white font-semibold px-8 py-3 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                    >
                        Discover HEI
                    </button>
                </div>
                <div className="absolute top-0 left-0 w-full z-20">
                    <Header />
                </div>
            </div>

            {/* Hero Image Section */}
            {/* <section className="pt-16 md:pt-20 bg-gradient-to-b from-gray-50 to-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-10">
                    <div className="relative w-full rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl image-zoom">
                        <div className="relative" style={{ paddingBottom: '45%' }}>
                            <img
                                src={InitialImage}
                                alt="Makerspace for Higher Educational Institutes"
                                className="absolute inset-0 w-full h-full object-cover object-center"
                            />
                        </div>
                    </div>
                </div>
            </section> */}

            {/* MAKERSPACE INTRO SECTION */}
            <section id="makerspace-intro" className="py-8 sm:py-12 md:py-16 lg:py-20 px-4 sm:px-6 md:px-8 lg:px-12 bg-white">
                <div className="max-w-7xl mx-auto">

                    {/* Title */}
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-blue-900 mb-2 sm:mb-3 md:mb-4 leading-tight fade-in-left">
                        IDEA LABS
                    </h1>

                    {/* Subtitle */}
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-700 max-w-full md:max-w-2xl lg:max-w-3xl mb-3 sm:mb-4 md:mb-6 leading-relaxed text-reveal delay-200">
                        Ecosystems built for students, faculty, and researchers
                        to turn ideas into working prototypes faster.
                    </p>

                    {/* Blue underline */}
                    <div className="w-10 sm:w-12 md:w-16 lg:w-20 h-1 bg-sky-500 mb-3 sm:mb-4 md:mb-6"></div>

                    {/* HEI Title */}
                    <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-2 sm:mb-3 md:mb-4 leading-tight text-reveal delay-400">
                        For Higher Educational Institutes
                    </h2>

                    {/* Process Line */}
                    <p className="text-xs sm:text-sm md:text-base lg:text-xl xl:text-2xl font-semibold text-gray-700 tracking-wide mb-3 sm:mb-4 md:mb-6 break-words leading-relaxed text-reveal delay-600">
                        IMAGINE <span className="text-sky-500">|</span> ENGINEER{" "}
                        <span className="text-sky-500">|</span> PROTOTYPE{" "}
                        <span className="text-sky-500">|</span> VALIDATE{" "}
                        <span className="text-sky-500">|</span> LAUNCH
                    </p>

                    {/* Description */}
                    <p className="text-xs sm:text-sm md:text-base lg:text-lg text-gray-700 leading-relaxed max-w-full md:max-w-2xl lg:max-w-3xl xl:max-w-4xl text-reveal delay-800">
                        We build high-velocity innovation ecosystems where students, faculty,
                        and research teams can turn ideas into tested, faster demo-ready
                        prototypes. With the right tools, space, and support under one roof
                        they build, test, iterate, and showcase outcomes with confidence
                        and impact.
                    </p>

                </div>
            </section>

            {/* Why Institutes Need a Makerspace Section */}
            <section className="pt-4 pb-8 sm:pt-6 sm:pb-12 md:pt-8 md:pb-16 lg:pt-10 lg:pb-20 px-4 sm:px-6 md:px-8 lg:px-12 bg-white">
                <div className="max-w-7xl mx-auto">

                    {/* Title */}
                    <div className="mb-8 sm:mb-12 md:mb-16 slide-up">
                        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 fade-in-left">
                            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
                                <span className="text-blue-500">Why Institutes</span>{" "}
                                <span className="text-gray-900">Need a IDEA Labs</span>
                            </h2>
                            <div className="w-16 sm:w-20 md:w-24 h-1 bg-[#0088cc]" />
                        </div>
                    </div>

                    {/* Description */}
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-800 font-medium mb-6 sm:mb-8 leading-relaxed">
                        IDEA Labs promote hands-on STEM learning, innovation, and product prototyping through a shared experiential space.
They help students and faculty develop 21st-century skills, multidisciplinary projects, and real-world problem-solving.
                    </p>

                    {/* Subtitle */}
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-800 font-semibold mb-6 sm:mb-8">
                        A IDEA Labs-driven ecosystem helps institutions:
                    </p>

                    {/* Two Column Layout: Points and Image */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center mb-6 sm:mb-8">
                        {/* Left: Icon Points */}
                        <div className="space-y-4 sm:space-y-5 md:space-y-6 lg:space-y-7">
                            {/* Point 1 */}
                            <div className="flex items-center gap-3 sm:gap-4 md:gap-5 stagger-item delay-200">
                                <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-blue-700 rounded-full overflow-hidden border-2 sm:border-3 md:border-4 border-blue-900 shadow-lg">
                                    <img src={whyIcon1} alt="Convert learning" className="w-full h-full object-cover" />
                                </div>
                                <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-800 leading-snug">
                                    Convert learning into tangible prototypes
                                </p>
                            </div>

                            {/* Point 2 */}
                            <div className="flex items-center gap-3 sm:gap-4 md:gap-5 stagger-item delay-400">
                                <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-blue-700 rounded-full overflow-hidden border-2 sm:border-3 md:border-4 border-blue-900 shadow-lg">
                                    <img src={whyIcon2} alt="Speed up projects" className="w-full h-full object-cover" />
                                </div>
                                <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-800 leading-snug">
                                    Speed up capstone projects, PoCs, and iterations
                                </p>
                            </div>

                            {/* Point 3 */}
                            <div className="flex items-center gap-3 sm:gap-4 md:gap-5 stagger-item delay-600">
                                <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-blue-700 rounded-full overflow-hidden border-2 sm:border-3 md:border-4 border-blue-900 shadow-lg">
                                    <img src={whyIcon3} alt="Show outcomes" className="w-full h-full object-cover" />
                                </div>
                                <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-800 leading-snug">
                                    Show real, demo-ready outcomes to industry, accreditation bodies, and grant agencies
                                </p>
                            </div>
                        </div>

                        {/* Right: Image */}
                        <div className="w-full sm:w-4/5 md:w-3/4 lg:w-full mx-auto lg:mx-0 mt-6 lg:mt-0">
                            <div className="relative w-full h-auto">
                                <img
                                    src={whymakerspace}
                                    alt="Students working in makerspace"
                                    className="w-full h-auto object-contain rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Bottom Statement */}
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-800 font-semibold leading-relaxed">
                        In short, it upgrades the institution from <span className="font-bold">classroom + lab</span> to a true <span className="font-bold">build-and-launch engine</span>.
                    </p>
                </div>

                {/* Features Row with Dashed Lines */}
                <section className="py-6 sm:py-8 md:py-10 bg-white">
                    <div className="relative flex flex-wrap justify-center items-start gap-6 sm:gap-8 md:gap-6 lg:gap-10 px-4 sm:px-6">
                        {/* Dashed connecting line */}
                        <div className="hidden lg:block absolute top-[70px] left-[15%] right-[15%] border-t-2 border-dashed border-[#0088cc]/40" />

                        {features.map((feature, index) => {
                            const delayClass = ['delay-100', 'delay-200', 'delay-300', 'delay-400', 'delay-500'][index] || '';
                            return (
                                <div key={index} className={`flex flex-col items-center text-center w-32 sm:w-36 md:w-40 lg:w-44 relative z-10 scale-in ${delayClass}`}>
                                    <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-36 lg:h-36 rounded-full border-[3px] sm:border-[4px] border-[#0088cc] overflow-hidden bg-white mb-3 sm:mb-4 shadow-lg hover:shadow-xl transition-shadow duration-300">
                                        <img
                                            src={feature.image}
                                            alt={feature.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <p className="font-bold text-gray-900 text-sm sm:text-base md:text-lg leading-tight">{feature.title}</p>
                                    <p className="font-bold text-gray-900 text-sm sm:text-base md:text-lg leading-tight">{feature.subtitle}</p>
                                </div>
                            );
                        })}
                    </div>
                </section>
            </section>

            {/* What We Build Section */}
            <section className="relative overflow-hidden bg-gradient-to-br from-blue-600 to-blue-700 py-10 sm:py-12 md:py-16 px-4 sm:px-6 lg:px-8">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10 items-center">

                        {/* Left Content Section */}
                        <div className="text-white space-y-4 sm:space-y-6 slide-up">
                            {/* Title with underline */}
                            <div className="mb-8 sm:mb-12 md:mb-16 slide-up">
                                <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                                    <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
                                        What We Build
                                    </h2>
                                    <div className="w-16 sm:w-20 md:w-24 h-1 bg-orange-500"></div>
                                </div>
                            </div>

                            {/* Subtitle */}
                            <p className="text-lg sm:text-xl md:text-2xl font-semibold text-reveal delay-200">
                                A Complete Product Development Ecosystem
                            </p>

                            {/* Bullet Points with Icons - Grid Layout */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 pt-4">
                                {/* Tools to prototype */}
                                <div className="flex items-center gap-3 stagger-item delay-300 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/20 transition-all duration-300">
                                    <FaTools className="text-3xl sm:text-4xl flex-shrink-0 text-orange-400" />
                                    <span className="text-sm sm:text-base md:text-lg font-medium">
                                        Tools to prototype
                                    </span>
                                </div>

                                {/* Space to experiment */}
                                <div className="flex items-center gap-3 stagger-item delay-400 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/20 transition-all duration-300">
                                    <FaDraftingCompass className="text-3xl sm:text-4xl flex-shrink-0 text-orange-400" />
                                    <span className="text-sm sm:text-base md:text-lg font-medium">
                                        Space to experiment
                                    </span>
                                </div>

                                {/* Systems to validate */}
                                <div className="flex items-center gap-3 stagger-item delay-500 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/20 transition-all duration-300">
                                    <FaCogs className="text-3xl sm:text-4xl flex-shrink-0 text-orange-400" />
                                    <span className="text-sm sm:text-base md:text-lg font-medium">
                                        Systems to validate
                                    </span>
                                </div>

                                {/* Support to scale */}
                                <div className="flex items-center gap-3 stagger-item delay-600 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/20 transition-all duration-300">
                                    <FaHandsHelping className="text-3xl sm:text-4xl flex-shrink-0 text-orange-400" />
                                    <span className="text-sm sm:text-base md:text-lg font-medium">
                                        Support to scale
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Right Image Section */}
                        <div className="w-full h-64 sm:h-80 md:h-96 lg:h-full fade-in-right">
                            <div className="w-full h-full rounded-2xl overflow-hidden shadow-2xl border-4 border-white/20">
                                <img
                                    src={webuild}
                                    alt="Student working on prototype"
                                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>




            {/* HOW WE WORK */}
            <section className="relative py-16 md:py-20 bg-gradient-to-b from-white to-gray-50 overflow-hidden">

                {/* Blueprint background */}
                <div
                    className="absolute inset-0 opacity-[0.05]"
                    style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%230088cc' stroke-width='0.5'%3E%3Cpath d='M0 10h60M0 20h60M0 30h60M0 40h60M0 50h60'/%3E%3Cpath d='M10 0v60M20 0v60M30 0v60M40 0v60M50 0v60'/%3E%3Ccircle cx='30' cy='30' r='15'/%3E%3Ccircle cx='30' cy='30' r='8'/%3E%3Cpath d='M0 0L60 60M60 0L0 60'/%3E%3C/g%3E%3C/svg%3E")`,
                    }}
                />

                <div className="relative z-10 px-4 sm:px-6 md:px-8 lg:px-16 max-w-7xl mx-auto">

                    {/* Title */}
                    <div className="mb-10 sm:mb-12 md:mb-16 slide-up">
                        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
                                <span className="text-[#0088cc]">How</span>{" "}
                                <span className="text-gray-900">We Work</span>
                            </h2>
                            <div className="w-16 sm:w-20 md:w-24 h-1 bg-[#0088cc]" />
                        </div>
                    </div>

                    {/* Steps */}
                    <div className="space-y-8 md:space-y-10">
                        {[
                            {
                                title: "Discover",
                                desc: "We understand your goals, users and the kind of innovation you want to enable.",
                                image: discover,
                            },
                            {
                                title: "Design",
                                desc: "We create a tailored IDEA Labs ecosystem—tools, layout, and workflow included.",
                                image: design,
                            },
                            {
                                title: "Build",
                                desc: "We set up the entire space end-to-end with seamless installation and integration.",
                                image: build,
                            },
                            {
                                title: "Enable",
                                desc: "We train and support your teams so innovators can start building and scale fast.",
                                image: enable,
                            },
                        ].map((step, i) => {
                            const delays = ['delay-200', 'delay-300', 'delay-400', 'delay-500'];
                            return (
                                <div
                                    key={i}
                                    className={`flex flex-col md:flex-row items-center gap-5 md:gap-8 p-6 md:p-8 bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 border-l-4 border-[#0088cc] stagger-item ${delays[i]}`}
                                >
                                    {/* Step Label */}
                                    <div className="bg-gradient-to-br from-[#1a3a5c] to-[#0088cc] text-white font-bold text-xl md:text-2xl px-10 py-4 rounded-xl min-w-[160px] text-center shrink-0 shadow-lg transform hover:scale-105 transition-transform duration-300">
                                        {step.title}
                                    </div>

                                    {/* Description */}
                                    <p className="text-gray-700 text-base sm:text-lg md:text-xl flex-1 text-center md:text-left leading-relaxed font-medium">
                                        {step.desc}
                                    </p>

                                    {/* Image */}
                                    <div className="w-40 h-28 sm:w-48 sm:h-32 md:w-52 md:h-36 rounded-2xl overflow-hidden shrink-0 shadow-xl border-2 border-gray-200 hover:scale-105 transition-transform duration-300">
                                        <img
                                            src={step.image}
                                            alt={step.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* INFRASTRUCTURE & EQUIPMENT */}
            <section className="relative py-8 sm:py-10 md:py-12 lg:py-16 bg-white">
                <div className="px-4 sm:px-6 md:px-8 max-w-7xl mx-auto">

                    {/* Section Title */}
                    <div className="mb-8 sm:mb-10 md:mb-12 fade-in-left">
                        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
                                <span className="text-[#0088cc]">Infrastructure</span>{" "}
                                <span className="text-gray-900">and Equipment</span>
                            </h2>
                            <div className="w-16 sm:w-20 md:w-24 h-1 bg-[#0088cc]" />
                        </div>
                    </div>

                    {/* Equipment Icons Row */}
                    <div className="relative flex flex-wrap justify-center items-start gap-6 sm:gap-8 md:gap-6 lg:gap-10 mb-8 sm:mb-10">

                        {/* Dashed connecting line */}
                        <div className="hidden lg:block absolute top-[70px] left-[12%] right-[12%] border-t-2 border-dashed border-[#0088cc]/40" />

                        {[
                            {
                                title: "Industrial-grade 3D Printers,laser cutters, CNC machines",
                                image: infra1
                            },
                            {
                                title: "CNC milling & PCB fabrication systems",
                                image: infra2
                            },
                            {
                                title: "IoT, Electronics & Robotics development stations",
                                image: infra3
                            },
                            {
                                title: "Startup workstations & product testing labs",
                                image: infra4
                            },
                            {
                                title: "Design, Simulation & product modeling software",
                                image: infra5
                            },
                        ].map((item, index) => {
                            const delays = ['delay-100', 'delay-200', 'delay-300', 'delay-400', 'delay-500'];
                            return (
                                <div
                                    key={index}
                                    className={`flex flex-col items-center text-center w-32 sm:w-36 md:w-40 lg:w-44 relative z-10 scale-in ${delays[index]}`}
                                >
                                    <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-36 lg:h-36 rounded-full border-[3px] sm:border-[4px] border-[#0088cc] overflow-hidden bg-white mb-3 sm:mb-4 shadow-lg hover:shadow-xl transition-shadow duration-300">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <p className="text-gray-800 text-xs sm:text-sm md:text-base font-medium leading-tight px-1 sm:px-2">
                                        {item.title}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Three Images Section */}
                <section className="py-6 sm:py-8 md:py-10 bg-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="relative w-full rounded-lg md:rounded-xl overflow-hidden shadow-lg">
                            <div className="relative" style={{ paddingBottom: '30%' }}>
                                <img
                                    src={infraandequipments}
                                    alt="Makerspace for Higher Educational Institutes"
                                    className="absolute inset-0 w-full h-full object-cover object-center"
                                />
                            </div>
                        </div>
                    </div>
                </section>

            </section>

            {/* Aligned with India's Startup Mission Section */}
            <section className="py-8 sm:py-10 md:py-12 bg-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Content Grid */}
                    <div className="bg-gray-100 p-6 sm:p-8 md:p-10 rounded-lg shadow-lg">
                        {/* Header with Orange Bar */}
                        <div className="mb-8 slide-up">
                            <div className="border-l-8 border-orange-500 pl-4 sm:pl-6">
                                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-blue-600">
                                    Aligned with <span className="text-gray-900">India's Startup Mission</span>
                                </h2>
                            </div>
                        </div>

                        {/* Two Column Layout */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
                            {/* Left: Bullet Points */}
                            <div className="space-y-4 sm:space-y-5">
                                <div className="flex items-start gap-3 stagger-item delay-200">
                                    <div className="flex-shrink-0 w-2 h-2 sm:w-3 sm:h-3 bg-blue-600 rounded-full mt-2"></div>
                                    <p className="text-base sm:text-lg md:text-xl text-gray-800 font-medium">
                                        Drives product innovation and prototype development
                                    </p>
                                </div>

                                <div className="flex items-start gap-3 stagger-item delay-300">
                                    <div className="flex-shrink-0 w-2 h-2 sm:w-3 sm:h-3 bg-blue-600 rounded-full mt-2"></div>
                                    <p className="text-base sm:text-lg md:text-xl text-gray-800 font-medium">
                                        Strengthens the startup and incubation ecosystem
                                    </p>
                                </div>

                                <div className="flex items-start gap-3 stagger-item delay-400">
                                    <div className="flex-shrink-0 w-2 h-2 sm:w-3 sm:h-3 bg-blue-600 rounded-full mt-2"></div>
                                    <p className="text-base sm:text-lg md:text-xl text-gray-800 font-medium">
                                        Enables research-to-market transformation
                                    </p>
                                </div>

                                <div className="flex items-start gap-3 stagger-item delay-500">
                                    <div className="flex-shrink-0 w-2 h-2 sm:w-3 sm:h-3 bg-blue-600 rounded-full mt-2"></div>
                                    <p className="text-base sm:text-lg md:text-xl text-gray-800 font-medium">
                                        Supports Make in India & Atmanirbhar Bharat initiatives
                                    </p>
                                </div>
                            </div>

                            {/* Right: Make in India Image */}
                            <div className="flex items-center justify-center fade-in-right">
                                <img
                                    src={makeinindia}
                                    alt="Make in India"
                                    className="w-full max-w-md h-auto object-contain"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Partners Section */}
            <Ourpartner />

            <Footer />
        </div>
    );
}


